module.exports = __webpack_public_path__ + "static/media/tax free.778938af.jpg";